import {getNestedTranslation, TranslationObject} from '@colonist/i18n'
import {ViewPopup} from './ViewPopup'
import {clientI18n} from '../ClientI18n'
import {createDivIn, createImgIn, createParagraphIn, setElementOnClick} from '../ui_utils/DomUtils'
import {BaseStoreItem} from '../../../../shared/store/BaseStoreItem'
import {StoreIconType, StoreItemCategory, StorePlayerColor} from '../../../../shared/entity_datas/StoreEnums'
import {ProfileEditAjaxEndPoints} from '../profile/ProfileEditAjaxEndPoints'
import {notificationController} from '../EntryShared'
import {AudioManager, AudioType} from '@colonist/audio'

export class ViewPopupSuccessfulPurchase extends ViewPopup {
    private readonly item: BaseStoreItem

    constructor(item: BaseStoreItem) {
        const title: TranslationObject = {key: 'strings:storePage.success.purchaseSuccess'}
        super(title, undefined, () => undefined, () => undefined, true)

        this.item = item

        this.createContent()
        this.initXButton()
        this.initCheckButton()

        this.show()
    }

    private createContent() {
        const contentContainer = createDivIn(this.body, 'popup-purchase-successful-content')

        createImgIn(contentContainer, this.item.image, 'popup-purchase-item-image')

        const itemNameText = clientI18n.t(this.item.name.key, this.item.name.options)
        const categoryText = this.getItemCategoryText()
        const titleText: TranslationObject = {
            key: 'strings:storePage.success.youGotItem',
            options: {itemName: itemNameText, category: categoryText},
        }
        const subtitleText: TranslationObject = {key: 'strings:storePage.success.findInProfile'}

        createParagraphIn(contentContainer, titleText, 'popup-purchase-title')
        createParagraphIn(contentContainer, subtitleText, 'popup-purchase-subtitle')
    }

    private initXButton() {
        this.xButton.classList.remove('btn_general_x')
        this.xButton.classList.add('btn_general_check')
    }

    private initCheckButton() {
        this.changeCheckButtonText({key: 'strings:storePage.success.useItNow'})
        setElementOnClick(this.checkButton, () => {
            AudioManager.play(AudioType.Click)
            void this.useItemAction()
            this.removePopup()
        })
    }

    private getItemCategoryText(): string {
        const category = this.item.category
        switch(category) {
            case StoreItemCategory.Color:
                return clientI18n.t('strings:storePage.sections.color.title', {context: 'one'})
            case StoreItemCategory.Icon:
                return clientI18n.t('strings:storePage.sections.avatar.title', {context: 'one'})
            default:
                return ''
        }
    }

    private async useItemAction() {
        const category = this.item.category

        switch(category) {
            case StoreItemCategory.Color:
                const playerColor = BaseStoreItem.getPlayerColorOfStorePlayerColor(this.item.type as StorePlayerColor)
                if(playerColor == undefined) return
                await ProfileEditAjaxEndPoints.updatePreferredColor(playerColor)
                const colorChangeMessage = getNestedTranslation({key: 'strings:homePage.header.defaultColorSelector.colorChanged'}, {color: this.item.name})
                notificationController.showNotification(this.item.image, colorChangeMessage)
                break
            case StoreItemCategory.Icon:
                await ProfileEditAjaxEndPoints.updateIcon(this.item.type as StoreIconType)
                const avatarChangeMessage = getNestedTranslation({key: 'strings:homePage.header.avatarSelector.avatarChanged'}, {icon: this.item.name})
                notificationController.showNotification(this.item.image, avatarChangeMessage)
                break
            default:
                break
        }
    }
}
